// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   PAGE
========================= */
.adminSignalementPage {
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;
  font-family: Arial, sans-serif;
}

/* =========================
   GRID / CARD
========================= */
.adminSignalementGrid {
  display: flex;
  justify-content: center;
}

.adminSignalementCard {
  border-radius: 12px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.14);
  padding: 16px;
}

.adminSignalementCardCenter {
  width: 100%;
  margin-top: 16px;
}

/* =========================
   HEADER
========================= */
.adminSignalementHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.adminSignalementTitle {
  font-weight: 900;
  font-size: 14px;
  color: var(--couleur-dark);
}

.adminSignalementSubtitle {
  margin-top: 4px;
  font-size: 12px;
  color: var(--gris-terciaire);
}

/* =========================
   BUTTONS
========================= */
.adminSignalementBtn {
  border: none;
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: filter 0.15s ease, opacity 0.15s ease;
}

.adminSignalementBtnSoft {
  background: rgba(0, 0, 0, 0.06);
  color: var(--couleur-dark);
}

.adminSignalementBtnSoft:hover {
  filter: brightness(0.96);
}

.adminSignalementBtn:disabled {
  opacity: 0.6;
  cursor: default;
}

/* =========================
   FILTERS
========================= */
.adminSignalementFilters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0 14px;
}

.adminSignalementSearch {
  flex: 1 1 360px;
  min-width: 260px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 999px;
  padding: 8px 12px;
  background: var(--white-principale);
}

.adminSignalementSearch i {
  color: var(--gris-terciaire);
}

.adminSignalementSearch input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 12px;
  color: var(--couleur-dark);
  background: transparent;
}

.adminSignalementSelects {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.adminSignalementSelects select {
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

/* =========================
   TABLE
========================= */
.adminSignalementTableWrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
}

.adminSignalementTable {
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
}

.adminSignalementTable thead th {
  text-align: left;
  font-size: 11px;
  color: var(--gris-terciaire);
  font-weight: 900;
  padding: 12px;
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid var(--gris-secondaire-2);
}

.adminSignalementTable tbody td {
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 12px;
  color: var(--couleur-dark);
  vertical-align: middle;
}

.adminSignalementTable tbody tr:hover {
  background: rgba(0, 0, 0, 0.02);
}

.muted {
  color: var(--gris-terciaire);
}

/* =========================
   USER CELL
========================= */
.adminSignalementCellUser {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 200px;
  cursor: pointer;
}

.adminSignalementCellUserText {
  min-width: 0;
}

.adminSignalementName {
  font-weight: 900;
  font-size: 12px;
  color: var(--couleur-dark);
}

/* =========================
   ARTICLE CELL
========================= */
.adminSignalementArticleCell {
  min-width: 260px;
  cursor: pointer;
}

.adminSignalementArticleTitle {
  font-weight: 900;
  font-size: 12px;
  color: var(--couleur-dark);
}

.adminSignalementArticleHint {
  margin-top: 4px;
  font-size: 11px;
  color: var(--gris-terciaire);
  line-height: 1.35;
}

/* clamp message */
.adminSignalementMsgClamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* =========================
   BADGES
========================= */
.adminSignalementBadge {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.02em;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.badgeActive {
  background: rgba(28, 180, 93, 0.12);
  color: #1cb45d;
}

.badgeSoft {
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
}

.badgeBlocked {
  background: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}

.badgeArchived {
  background: rgba(0, 0, 0, 0.08);
}

/* =========================
   ACTIONS
========================= */
.colActions {
  width: 110px;
}

.adminSignalementActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.adminSignalementIconBtn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: var(--white-principale);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.adminSignalementIconBtn:hover {
  filter: brightness(0.98);
}

/* =========================
   EMPTY / LOADER
========================= */
.adminSignalementEmpty {
  padding: 22px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--gris-terciaire);
  text-align: center;
}

/* =========================
   PAGINATION
========================= */
.adminSignalementPagination {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.adminSignalementPagination .adminSignalementIconBtn {
  transition: filter .15s ease, transform .06s ease;
}

.adminSignalementPagination .adminSignalementIconBtn:active {
  transform: scale(.98);
}

.adminSignalementPagination .adminSignalementIconBtn:disabled {
  opacity: .55;
  cursor: default;
}

/* =========================
   RESPONSIVE
========================= */
.hideOnMobile {
  display: table-cell;
}

.adminSignalementMobileMeta {
  display: none;
}

.adminSignalementDateRange {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: end;
}

.adminSignalementDateField {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.adminSignalementDateLabel {
  font-size: 10px;
  font-weight: 800;
  color: var(--gris-terciaire);
}

.adminSignalementDateField input[type="date"] {
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

/* Nouvelle affichage */
.adminSignalementList {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.signalementCard {
  background: white;
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  border-left: 5px solid transparent;
}

.pendingCard {
  border-left: 5px solid #f39c12;
}

.signalementCardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.signalementTitle {
  font-size: 16px;
  font-weight: 600;
}

.signalementMeta {
  font-size: 13px;
  color: gray;
}

.signalementCardBody {
  display: flex;
  gap: 40px;
  margin-top: 15px;
}

.signalementColumn .label {
  font-size: 12px;
  color: gray;
}

.signalementColumn .value {
  font-weight: 500;
  margin-top: 4px;
}

.clickable {
  cursor: pointer;
  color: #007bff;
}

.countBadge {
  margin-top: 6px;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 20px;
  background: #eef2ff;
}

.dangerHigh {
  background: #ffe5e5;
  color: #d60000;
}

.signalementMessage {
  margin-top: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
  font-size: 14px;
}

.signalementActions {
  display: flex;
  gap: 10px;
  margin-top: 15px;
  flex-wrap: wrap;
}

.btnValidate {
  background: #28a745;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 8px;
}

.btnReject {
  background: #dc3545;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 8px;
}

.btnView {
  background: #6c757d;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 8px;
}

.btnArchive {
  background: #343a40;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 8px;
}


@media (max-width: 720px) {
  .hideOnMobile {
    display: none !important;
  }

  .adminSignalementTable {
    min-width: 0;
  }

  .adminSignalementTable thead {
    display: none;
  }

  .adminSignalementTableWrap {
    border: none;
  }

  .adminSignalementTable tbody {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .adminSignalementTable tbody tr {
    display: block;
    border: 1px solid var(--gris-secondaire-2);
    border-radius: 14px;
    padding: 10px;
    background: var(--white-principale);
  }

  .adminSignalementTable tbody td {
    display: block;
    border-bottom: none;
    padding: 6px 4px;
  }

  .colActions {
    width: auto;
  }

  .adminSignalementActions {
    justify-content: flex-end;
    margin-top: 6px;
  }

  .adminSignalementMobileMeta {
    display: block;
    margin-top: 8px;
    font-size: 11px;
    color: var(--gris-terciaire);
    line-height: 1.35;
  }

  .adminSignalementMobileMeta div {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/admin/gestionSignalement/AdminSignalementsPage.css"],"names":[],"mappings":"AAAA;;2BAE2B;AAC3B;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA;;2BAE2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;2BAE2B;AAC3B;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;2BAE2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;AACF","sourcesContent":["/* =========================\n   PAGE\n========================= */\n.adminSignalementPage {\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n  font-family: Arial, sans-serif;\n}\n\n/* =========================\n   GRID / CARD\n========================= */\n.adminSignalementGrid {\n  display: flex;\n  justify-content: center;\n}\n\n.adminSignalementCard {\n  border-radius: 12px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.14);\n  padding: 16px;\n}\n\n.adminSignalementCardCenter {\n  width: 100%;\n  margin-top: 16px;\n}\n\n/* =========================\n   HEADER\n========================= */\n.adminSignalementHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.adminSignalementTitle {\n  font-weight: 900;\n  font-size: 14px;\n  color: var(--couleur-dark);\n}\n\n.adminSignalementSubtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n/* =========================\n   BUTTONS\n========================= */\n.adminSignalementBtn {\n  border: none;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: filter 0.15s ease, opacity 0.15s ease;\n}\n\n.adminSignalementBtnSoft {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--couleur-dark);\n}\n\n.adminSignalementBtnSoft:hover {\n  filter: brightness(0.96);\n}\n\n.adminSignalementBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* =========================\n   FILTERS\n========================= */\n.adminSignalementFilters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 12px 0 14px;\n}\n\n.adminSignalementSearch {\n  flex: 1 1 360px;\n  min-width: 260px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 999px;\n  padding: 8px 12px;\n  background: var(--white-principale);\n}\n\n.adminSignalementSearch i {\n  color: var(--gris-terciaire);\n}\n\n.adminSignalementSearch input {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: transparent;\n}\n\n.adminSignalementSelects {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.adminSignalementSelects select {\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n/* =========================\n   TABLE\n========================= */\n.adminSignalementTableWrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n}\n\n.adminSignalementTable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 980px;\n}\n\n.adminSignalementTable thead th {\n  text-align: left;\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  font-weight: 900;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid var(--gris-secondaire-2);\n}\n\n.adminSignalementTable tbody td {\n  padding: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  font-size: 12px;\n  color: var(--couleur-dark);\n  vertical-align: middle;\n}\n\n.adminSignalementTable tbody tr:hover {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.muted {\n  color: var(--gris-terciaire);\n}\n\n/* =========================\n   USER CELL\n========================= */\n.adminSignalementCellUser {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 200px;\n  cursor: pointer;\n}\n\n.adminSignalementCellUserText {\n  min-width: 0;\n}\n\n.adminSignalementName {\n  font-weight: 900;\n  font-size: 12px;\n  color: var(--couleur-dark);\n}\n\n/* =========================\n   ARTICLE CELL\n========================= */\n.adminSignalementArticleCell {\n  min-width: 260px;\n  cursor: pointer;\n}\n\n.adminSignalementArticleTitle {\n  font-weight: 900;\n  font-size: 12px;\n  color: var(--couleur-dark);\n}\n\n.adminSignalementArticleHint {\n  margin-top: 4px;\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  line-height: 1.35;\n}\n\n/* clamp message */\n.adminSignalementMsgClamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* =========================\n   BADGES\n========================= */\n.adminSignalementBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: 0.02em;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.badgeActive {\n  background: rgba(28, 180, 93, 0.12);\n  color: #1cb45d;\n}\n\n.badgeSoft {\n  background: rgba(255, 193, 7, 0.15);\n  color: #ffc107;\n}\n\n.badgeBlocked {\n  background: rgba(220, 53, 69, 0.12);\n  color: #dc3545;\n}\n\n.badgeArchived {\n  background: rgba(0, 0, 0, 0.08);\n}\n\n/* =========================\n   ACTIONS\n========================= */\n.colActions {\n  width: 110px;\n}\n\n.adminSignalementActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.adminSignalementIconBtn {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: var(--white-principale);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.adminSignalementIconBtn:hover {\n  filter: brightness(0.98);\n}\n\n/* =========================\n   EMPTY / LOADER\n========================= */\n.adminSignalementEmpty {\n  padding: 22px 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  color: var(--gris-terciaire);\n  text-align: center;\n}\n\n/* =========================\n   PAGINATION\n========================= */\n.adminSignalementPagination {\n  margin-top: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.adminSignalementPagination .adminSignalementIconBtn {\n  transition: filter .15s ease, transform .06s ease;\n}\n\n.adminSignalementPagination .adminSignalementIconBtn:active {\n  transform: scale(.98);\n}\n\n.adminSignalementPagination .adminSignalementIconBtn:disabled {\n  opacity: .55;\n  cursor: default;\n}\n\n/* =========================\n   RESPONSIVE\n========================= */\n.hideOnMobile {\n  display: table-cell;\n}\n\n.adminSignalementMobileMeta {\n  display: none;\n}\n\n.adminSignalementDateRange {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: end;\n}\n\n.adminSignalementDateField {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.adminSignalementDateLabel {\n  font-size: 10px;\n  font-weight: 800;\n  color: var(--gris-terciaire);\n}\n\n.adminSignalementDateField input[type=\"date\"] {\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n/* Nouvelle affichage */\n.adminSignalementList {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.signalementCard {\n  background: white;\n  padding: 20px;\n  border-radius: 14px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);\n  border-left: 5px solid transparent;\n}\n\n.pendingCard {\n  border-left: 5px solid #f39c12;\n}\n\n.signalementCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.signalementTitle {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.signalementMeta {\n  font-size: 13px;\n  color: gray;\n}\n\n.signalementCardBody {\n  display: flex;\n  gap: 40px;\n  margin-top: 15px;\n}\n\n.signalementColumn .label {\n  font-size: 12px;\n  color: gray;\n}\n\n.signalementColumn .value {\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n.clickable {\n  cursor: pointer;\n  color: #007bff;\n}\n\n.countBadge {\n  margin-top: 6px;\n  font-size: 12px;\n  padding: 3px 8px;\n  border-radius: 20px;\n  background: #eef2ff;\n}\n\n.dangerHigh {\n  background: #ffe5e5;\n  color: #d60000;\n}\n\n.signalementMessage {\n  margin-top: 15px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.signalementActions {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n}\n\n.btnValidate {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 8px;\n}\n\n.btnReject {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 8px;\n}\n\n.btnView {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 8px;\n}\n\n.btnArchive {\n  background: #343a40;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 8px;\n}\n\n\n@media (max-width: 720px) {\n  .hideOnMobile {\n    display: none !important;\n  }\n\n  .adminSignalementTable {\n    min-width: 0;\n  }\n\n  .adminSignalementTable thead {\n    display: none;\n  }\n\n  .adminSignalementTableWrap {\n    border: none;\n  }\n\n  .adminSignalementTable tbody {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .adminSignalementTable tbody tr {\n    display: block;\n    border: 1px solid var(--gris-secondaire-2);\n    border-radius: 14px;\n    padding: 10px;\n    background: var(--white-principale);\n  }\n\n  .adminSignalementTable tbody td {\n    display: block;\n    border-bottom: none;\n    padding: 6px 4px;\n  }\n\n  .colActions {\n    width: auto;\n  }\n\n  .adminSignalementActions {\n    justify-content: flex-end;\n    margin-top: 6px;\n  }\n\n  .adminSignalementMobileMeta {\n    display: block;\n    margin-top: 8px;\n    font-size: 11px;\n    color: var(--gris-terciaire);\n    line-height: 1.35;\n  }\n\n  .adminSignalementMobileMeta div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
